/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./RemoteSVG.vue?vue&type=template&id=5c8e88ae"
import script from "./RemoteSVG.vue?vue&type=script&lang=js"
export * from "./RemoteSVG.vue?vue&type=script&lang=js"
import style0 from "./RemoteSVG.vue?vue&type=style&index=0&id=5c8e88ae&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports